module.exports = __webpack_public_path__ + "img/95.d6f593d1.jpg";